import React, { useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AudioForm from '../components/audio/AudioForm';

const mockGetById = (id: string | undefined) => {
  if (!id) return null;
  if (id === '1') {
    return {
      id: '1',
      title: 'The Great Gatsby - Audiobook',
      description: 'Complete audiobook of The Great Gatsby',
      author: 'F. Scott Fitzgerald',
      narrator: 'John Smith',
      duration: 3600,
      isPublished: true,
      isPremium: false,
      coverImage: { url: '/api/placeholder/100/100' },
      file: { fileName: 'gatsby-audio.mp3' },
    } as any;
  }
  return null;
};

const AudioUpsert: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const isEdit = Boolean(id);
  const audio = useMemo(() => mockGetById(id), [id]);

  const [saving, setSaving] = useState(false);
  
  const handleSubmit = async (success: boolean) => {
    if (success) {
      navigate('/audio');
    }
  };

  const handleCancel = () => navigate('/audio');

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{isEdit ? 'Edit Audio Book' : 'Add New Audio Book'}</h1>
          <p className="text-gray-600 mt-1">{isEdit ? 'Update the audio details' : 'Create a new audio entry'}</p>
        </div>
      </div>
      <AudioForm audio={audio} onSubmit={handleSubmit} onCancel={handleCancel} loading={saving} />
    </div>
  );
};

export default AudioUpsert;


